import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Loading } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "loading" }, _ctx.$attrs), [
    _createVNode(_component_el_icon, {
      class: "is-loading",
      size: "30",
      color: "#999"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading))
      ]),
      _: 1
    })
  ], 16))
}
}

})